export default __webpack_public_path__ + "static/media/Black-PointOnImage.77a4bf4f.svg";